// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"696":"b760a05a82f9f1ea","2888":"903a25b3b470b699","9351":"f3690d84c3bb2e61"}[chunkId] + ".css";
};